import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { adminRoute, publicAdminRoutes, privateAdminRoutes, userRoute } from './utils/constants/route';
import { AdminMainLayout } from './layouts';
import { ToastContainer } from 'react-toastify';
import 'mapbox-gl/dist/mapbox-gl.css';
type Props = {};

const App = (props: Props) => {
  return (
    <HashRouter>
      <Routes>
        {/* Admin public route */}
        <Route path={userRoute.base} element={<Navigate to={`${adminRoute.base}${adminRoute.login}`} />}></Route>
        <Route path={adminRoute.base} element={<Navigate to={`${adminRoute.base}${adminRoute.login}`} />}></Route>
        <Route path={adminRoute.base}>
          {publicAdminRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>
        {/* Private route */}
        <Route path={adminRoute.base} element={<AdminMainLayout />}>
          {privateAdminRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>
      </Routes>
      <ToastContainer newestOnTop autoClose={5000} theme='light' limit={1} />
    </HashRouter>
  );
};

export default App;
